module.exports = function(value) {
	var v = Number(value);
	if (isNaN(v)) {
		return;
	}

	if (this.decimals === undefined) {
		this.decimals = 1;
	}

	this.target = this.target || 85;
	this.ok = this.ok || this.target * .6;
	this.kindabad = this.kindabad || this.ok * .6;
	var reverse = this.reverse || false;

	var within = function(v, target) {
		if (reverse) {
			return v <= target;
		} else {
			return v >= target;
		}
	};

	this.value = v.toFixed(this.decimals);
	var rating = 'bad'
	if (within(v, this.target)) {
		rating = 'good';
	} else if (within(v, this.ok)) {
		rating = 'ok';
	} else if (within(v, this.kindabad)) {
		rating = 'kinda-bad';
	}

	this.classList.add(rating);
};
